import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reassign",
  "use": "icon-reassign-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-reassign\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.84 2.843a.833.833 0 0 0-1.347.98l2.37 3.26H3.334a.833.833 0 0 0 0 1.667h12.53c1.363 0 2.15-1.545 1.348-2.647l-2.37-3.26ZM5.16 16.74a.833.833 0 0 0 1.347-.98l-2.37-3.26h12.53a.833.833 0 1 0 0-1.667H4.137c-1.363 0-2.15 1.546-1.348 2.647l2.37 3.26Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol